import { InsightsErrorState } from "../../components/Insights/InsightsAsyncState";
import PricingReportQuarterlySummaryCards from "./PricingReportQuarterlySummaryCards";

export default function PricingReportQuarterlySummarySection({
  quarterlySummaryStats,
  isQuarterlySummaryLoading,
  quarterlySummaryError,
  selectedProvince = null,
  selectedRetailers = [],
}) {
  return (
    <>
      {quarterlySummaryError ? (
        <InsightsErrorState
          message={quarterlySummaryError}
          fallbackMessage="Something went wrong while loading quarterly summary data."
        />
      ) : null}
      <PricingReportQuarterlySummaryCards
        quarterlySummaryStats={quarterlySummaryStats}
        isQuarterlySummaryLoading={isQuarterlySummaryLoading}
        selectedProvince={selectedProvince}
        selectedRetailers={selectedRetailers}
      />
    </>
  );
}
